import { render, staticRenderFns } from "./BoxWordStatisticsWordviewChart.vue?vue&type=template&id=2bc56588&"
import script from "./BoxWordStatisticsWordviewChart.vue?vue&type=script&lang=js&"
export * from "./BoxWordStatisticsWordviewChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports